export function showAlert(state, show){
  state.alertVisible = show;
}